import React from "react";

import { cx } from "class-variance-authority";

import * as theme from "./Pagination.css";

export function PaginationNav({
    className,
    "aria-label": ariaLabel = "pagination",
    ...props
}: React.ComponentProps<"nav">) {
    return (
        <nav
            role="navigation"
            aria-label={ariaLabel}
            data-slot="pagination"
            className={cx(theme.pagination, className)}
            {...props}
        />
    );
}
